import moment from "moment";

export enum BatchRuleType {
  Video = 1,
  Audio = 2,
  Subtitles = 3,
  Packshot = 4,
  Trailer = 5,
}

export class BatchRule {
  constructor(
    public id: number,
    public name: string,
    public format: string,
    public idFormat: string,
    public type: BatchRuleType,
    public dateCreated: moment.Moment,
    public audioLanguage: string,
    public subtitlesLanguage: string,
    public subtitlesFps: number,
    public subtitlesOffset: number,
  ) {}
}
